import { Skeleton } from 'antd';
import React from 'react';

const PDFSkeleton = () => {
  return (
    <div style={{ 
      padding: '24px',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* PDF toolbar skeleton */}
      <div style={{ marginBottom: 16 }}>
        <Skeleton.Button active style={{ width: 200, height: 32 }} />
      </div>
      
      {/* PDF page content skeleton */}
      <div style={{ 
        flex: 1,
        border: '1px solid #d9d9d9',
        borderRadius: 4,
        padding: 24,
        backgroundColor: 'rgba(0, 0, 0, 0.02)'
      }}>
        <Skeleton active paragraph={{ rows: 12 }} />
      </div>
      
      {/* PDF navigation skeleton */}
      <div style={{ marginTop: 16, textAlign: 'center' }}>
        <Skeleton.Button active style={{ width: 150, height: 32 }} />
      </div>
    </div>
  );
};

export default PDFSkeleton;
